import "./index.css";

import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";

import App from "./App";
import { clearStaleAssetReloadFlag, installStaleAssetReloadHandlers } from "./lib/reloadOnceForStaleAssets";
import { store } from "./store";

// Import your Publishable Key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

// Disable console logs in production
if (import.meta.env.MODE === "production") {
  const silentConsoleMethod = (): undefined => undefined;
  const appConsole = Reflect.get(globalThis, "console") as Console;

  appConsole.log = silentConsoleMethod;
  appConsole.debug = silentConsoleMethod;
  appConsole.info = silentConsoleMethod;
  appConsole.warn = silentConsoleMethod;
  // Optionally keep console.error for critical errors
  // console.error = () => {};
}

// Initial data prefetch removed; pages/components fetch as needed via authenticated hooks

installStaleAssetReloadHandlers();
clearStaleAssetReloadFlag();

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App />
  </Provider>,
);
